import { useQuery } from '@tanstack/react-query';
import { getFeatureFlags } from 'services/portfolios/portfolioService';

const useGetFeatureFlags = () => {
  return useQuery({
    queryKey: ['useGetFeatureFlags'],
    queryFn: () => getFeatureFlags(),
  });
};

export default useGetFeatureFlags;
